import { render, staticRenderFns } from "./NewsNavigation.vue?vue&type=template&id=338db157&scoped=true&"
import script from "./NewsNavigation.vue?vue&type=script&lang=js&"
export * from "./NewsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./NewsNavigation.vue?vue&type=style&index=0&id=338db157&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338db157",
  null
  
)

export default component.exports